import { ROUTE } from "../../../routes";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { DigioMandateStatus, ImportScriptSrc } from "../../../configs/constants";
import SharedPropsService from "../../../SharedPropsService";
import { getDigioForAutoPay, nextStepCredStepper, removeUrlWithoutReload } from "../../../configs/utils";
import { ACTION } from "./types";
import AsyncStorage from "@react-native-async-storage/async-storage";
export const contactUs = async (action, _datastore, { navigate, setDatastore, importScript, network, digio, showPopup }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const onLoadRedirection = async (action, _datastore, { navigate, setDatastore, importScript, network, digio, showPopup }) => {
    const user = await network.post(api.userContext, {}, {
        headers: await getAppHeader(),
    });
    await SharedPropsService.setUser(user.data);
    let isSuccess;
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.data.linkedApplications[0].applicationId;
    removeUrlWithoutReload("digio_autopay_response");
    removeUrlWithoutReload("status");
    removeUrlWithoutReload("digio_doc_id");
    removeUrlWithoutReload("message");
    removeUrlWithoutReload("npci_txn_id");
    await network
        .get(`${api.digioMandateCheckRequestStatusOnCallBack}${applicationId}`, {
        headers: await getAppHeader(),
    }).then(async (response) => {
        if (response.data.stepResponseObject ===
            DigioMandateStatus.COMPLETED) {
            isSuccess = true;
        }
        else {
            isSuccess = false;
        }
    });
    const routeObj = await nextStepCredStepper();
    if (isSuccess) {
        setTimeout(async () => {
            await navigate(routeObj.routeId);
        }, 3000);
    }
};
export const goToNextStep = async (action, _datastore, { goBack, navigate }) => {
    const routeObj = await nextStepCredStepper();
    await navigate(routeObj.routeId, routeObj.params);
};
let pollInterval;
export const callDigioAgain = async (action, _datastore, { navigate, setDatastore, importScript, network, digio, showPopup }) => {
    removeUrlWithoutReload("digio_autopay_response");
    removeUrlWithoutReload("status");
    removeUrlWithoutReload("digio_doc_id");
    removeUrlWithoutReload("message");
    removeUrlWithoutReload("npci_txn_id");
    const user = await network.post(api.userContext, {}, {
        headers: await getAppHeader(),
    });
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.data.linkedApplications[0].applicationId;
    importScript(ImportScriptSrc.DIGIO_SCRIPT, getDigioForAutoPay, async (digio_response) => {
        clearInterval(pollInterval);
        network
            .get(`${api.digioMandateCheckRequestStatusOnCallBack}${applicationId}`, {
            headers: await getAppHeader(),
        })
            .then(async (response) => {
            if (response.status === 200 &&
                response.data.stepResponseObject ===
                    DigioMandateStatus.COMPLETED) {
                const user = await SharedPropsService.getUser();
                user.linkedApplications[0] =
                    response.data.updatedApplicationObj;
                await SharedPropsService.setUser(user);
                await showPopup({
                    type: 'SUCCESS',
                    title: 'AutoPay done successfully!',
                    subTitle: 'You will be redirected to next step \n' +
                        'in few seconds',
                    ctaLabel: 'Continue',
                    shouldAutoNavigate: true,
                    isAutoTriggerCta: false,
                    ctaAction: {
                        routeId: ROUTE.DIGIO_AUTOPAY_REDIRECTION,
                        type: ACTION.SUCCESS_VERIFICATION,
                        payload: {},
                    },
                });
            }
        });
    }, async (digio_response) => {
        clearInterval(pollInterval);
        network
            .get(`${api.digioMandateCheckRequestStatusOnCallBack}${applicationId}`, {
            headers: await getAppHeader(),
        })
            .then(async (response) => {
            if (response.data.stepResponseObject ===
                DigioMandateStatus.REQUESTED) {
                await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, 'btnItem', {
                    loading: false,
                });
            }
            else if (response.status === 200 &&
                response.data.stepResponseObject ===
                    DigioMandateStatus.EXPIRED) {
                await navigate(ROUTE.DIGIO_AUTOPAY_REDIRECTION);
            }
            else {
                await showPopup({
                    type: 'SUCCESS',
                    title: 'AutoPay done successfully!',
                    subTitle: 'You will be redirected to next step \n' +
                        'in few seconds',
                    ctaLabel: 'Continue',
                    shouldAutoNavigate: true,
                    isAutoTriggerCta: false,
                    ctaAction: {
                        routeId: ROUTE.DIGIO_AUTOPAY_REDIRECTION,
                        type: ACTION.SUCCESS_VERIFICATION,
                        payload: {},
                    },
                });
            }
        });
    });
    // Digio Kyc Mandate
    await network
        .get(`${api.digioMandateInitiateRequest}${applicationId}`, {
        headers: await getAppHeader(),
    })
        .then(response => {
        if (response.status === 200) {
            if (response.data && response.data.stepResponseObject) {
                console.log('init: ', response.data);
                const stepResponseObjectId = response.data.stepResponseObject;
                digio.init();
                digio.submit(stepResponseObjectId, user.data.user.phoneNumber);
                //polling
                pollInterval = setInterval(async () => {
                    network
                        .get(`${api.digioMandateCheckRequestStatus}${applicationId}`, {
                        headers: await getAppHeader(),
                    }, async () => { return; }, {
                        disableDefault: true
                    })
                        .then(async (res) => {
                        if (res &&
                            res.data &&
                            res.data.stepResponseObject ===
                                DigioMandateStatus.SIGNED) {
                            const user = await SharedPropsService.getUser();
                            user.linkedApplications[0] =
                                response.data.updatedApplicationObj;
                            await SharedPropsService.setUser(user);
                            clearInterval(pollInterval);
                            await setDatastore(ROUTE.DIGIO_MANDATE_SIGN, 'btnItem', {
                                loading: false,
                            });
                            await showPopup({
                                type: 'SUCCESS',
                                title: 'Mandate completed successfully',
                                // subTitle:
                                //     "Interest charges will be deducted automatically every month.",
                                ctaLabel: 'Continue',
                                primary: true,
                                // ctaAction: {
                                //     routeId: ROUTE.DIGIO_MANDATE_SIGN,
                                //     type: ACTION.SUCCESS_VERIFICATION,
                                //     payload: {},
                                // },
                            });
                        }
                        else if (res &&
                            res.data &&
                            res.data.stepResponseObject ===
                                DigioMandateStatus.EXPIRED) {
                            showPopup({
                                type: 'FAILED',
                                title: 'Something went wrong',
                                // subTitle:
                                //     "Interest charges will be deducted automatically every month.",
                                ctaLabel: 'Try again',
                                primary: true,
                                // ctaAction: {
                                //     routeId: ROUTE.DIGIO_MANDATE_SIGN,
                                //     type: ACTION.FAILED_VERIFICATION,
                                //     payload: {},
                                // },
                            });
                            console.log('Verification Failed');
                            clearInterval(pollInterval);
                            await setDatastore(ROUTE.DIGIO_AUTOPAY_INPROGRESS, 'btnItem', {
                                loading: false,
                            });
                        }
                    });
                }, 5000);
            }
        }
    })
        .catch(error => {
        console.log(error);
    });
};
export const successVerification = async (action, _datastore, { network, navigate }) => {
    const user = await network.post(api.userContext, {}, {
        headers: await getAppHeader(),
    });
    await SharedPropsService.setUser(user.data);
    const routeObj = await nextStepCredStepper();
    await navigate(routeObj.routeId, routeObj.params);
};
